/**
 * @generated SignedSource<<5c9e5edf43f7377c9adc2b0f3e224d02>>
 * @relayHash 77c6f4d982039a626f9800e374bc4596
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-commerce/458.0.0-2024-04-16T08:13:38.881Z/multiStageCheckoutTransactionQuery

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type PaymentMethodApiType = "ach" | "affirmCreditCard" | "applePay" | "cash" | "check" | "creditCard" | "creditToUserAccount" | "directPayment" | "discount" | "klarna" | "notAvailable" | "onPlatformWireTransfer" | "other" | "payLater" | "payPalAccount" | "unknown" | "wireTransfer" | "%future added value";
export type ShipmentType = "EXTERNALLY_ARRANGED" | "FIRSTDIBS_FACILITATED" | "LOCAL_PICKUP" | "%future added value";
export type TransactionType = "NEGOTIABLE" | "NON_NEGOTIABLE" | "OFF_PLATFORM" | "PRE_AUTH_NEGOTIATION" | "%future added value";
export type TransactionMultiStageCheckoutInput = {
  authorizationCode?: string | null;
  billingAddress?: AddressInput | null;
  buyerChargeCurrency?: Currency | null;
  buyerId?: string | null;
  clientMutationId?: string | null;
  country?: string | null;
  currencyConversionRateEventId?: string | null;
  cvcUpdateToken?: string | null;
  defaultShipping?: boolean | null;
  expectedBuyerTotal?: number | null;
  expectedBuyerTotalCurrency?: Currency | null;
  fdfQuoteABTestVariant?: string | null;
  giftMessage?: string | null;
  is3dsVerified?: boolean | null;
  isCustomQuote?: boolean | null;
  isGift?: boolean | null;
  isTaxExempt?: boolean | null;
  isVatReverseCharge?: boolean | null;
  itemId: string;
  offerAmountPerItem?: number | null;
  offerCurrency?: Currency | null;
  offerNotes?: string | null;
  paymentMethodApiType?: PaymentMethodApiType | null;
  paymentMethodNonce?: string | null;
  paymentMethodToken?: string | null;
  paymentProcessor?: string | null;
  projectId?: string | null;
  promoCode?: string | null;
  quantity?: number | null;
  shipmentNotes?: string | null;
  shipmentQuoteId?: string | null;
  shipmentType?: ShipmentType | null;
  shippingAddressId?: string | null;
  sidemark?: string | null;
  skuId?: string | null;
  transactionId?: string | null;
  transactionType: TransactionType;
  zipCode?: string | null;
};
export type AddressInput = {
  active?: boolean | null;
  addressBookMember?: boolean | null;
  city?: string | null;
  company?: string | null;
  contact?: string | null;
  country?: string | null;
  firstName?: string | null;
  label?: string | null;
  lastName?: string | null;
  line1?: string | null;
  line2?: string | null;
  phoneNumber?: string | null;
  state?: string | null;
  zipCode?: string | null;
};
export type multiStageCheckoutTransactionQuery$variables = {
  buyerId?: string | null;
  displayCurrency?: Currency | null;
  fdfQuoteABTestVariant?: string | null;
  hasAvailableOptions: boolean;
  hasSetUpCheckout: boolean;
  hasTradeStatus: boolean;
  hasUserId: boolean;
  input: TransactionMultiStageCheckoutInput;
  isMobile: boolean;
  itemId: string;
  userCountryCode?: string | null;
  userIds: ReadonlyArray<string | null>;
};
export type multiStageCheckoutTransactionQuery$data = {
  readonly viewer: {
    readonly computeTransactionMultiStageCheckout: {
      readonly transaction: {
        readonly availablePaymentMethodsForTransaction: ReadonlyArray<{
          readonly paymentMethodType: string | null;
        } | null> | null;
        readonly buyerInvoice: {
          readonly invoiceItems: ReadonlyArray<{
            readonly code: string | null;
            readonly totalAmount: {
              readonly amount: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly checkoutPageViewTracking?: any | null;
        readonly serviceId: string | null;
        readonly summary: {
          readonly invoiceSummary: {
            readonly buyerCurrentInvoicePromotionTotal: {
              readonly amount: number | null;
              readonly currency: Currency | null;
            } | null;
          } | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"CheckoutLayout_transaction" | "checkoutSetUpActions_transaction" | "useTrackCheckoutLoadEvent_transaction" | "useTransactionRecomputed_transaction">;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"CheckoutLayout_viewer" | "checkoutSetUpActions_viewer">;
  };
};
export type multiStageCheckoutTransactionQuery = {
  response: multiStageCheckoutTransactionQuery$data;
  variables: multiStageCheckoutTransactionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "buyerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "displayCurrency"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fdfQuoteABTestVariant"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasAvailableOptions"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasSetUpCheckout"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasTradeStatus"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasUserId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isMobile"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v10 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userIds"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chargeCurrencies",
  "storageKey": null
},
v13 = {
  "alias": "forceStripeOn",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "forceStripeOn"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"forceStripeOn\")"
},
v14 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v15 = {
  "kind": "Variable",
  "name": "countryCode",
  "variableName": "userCountryCode"
},
v16 = [
  (v15/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCheckoutBlocked",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentMethodType",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportingPaymentProcessors",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivateOffer",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAutomatedOffer",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmounts",
  "kind": "LinkedField",
  "name": "convertedAmounts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "USD",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPreAuthNegotiation",
  "storageKey": null
},
v26 = {
  "condition": "hasSetUpCheckout",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": [
        (v15/*: any*/),
        {
          "kind": "Variable",
          "name": "fdfQuoteABTestVariant",
          "variableName": "fdfQuoteABTestVariant"
        },
        {
          "kind": "Variable",
          "name": "hasAvailableOptions",
          "variableName": "hasAvailableOptions"
        }
      ],
      "kind": "ScalarField",
      "name": "checkoutPageViewTracking",
      "storageKey": null
    }
  ]
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v29 = [
  (v28/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "totalAmount",
  "plural": false,
  "selections": (v29/*: any*/),
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v32 = [
  (v31/*: any*/),
  (v28/*: any*/)
],
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v35 = [
  (v34/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "abbreviation",
    "storageKey": null
  }
],
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v38 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "INTERNATIONAL"
  }
],
v39 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isPopUpEnabled",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isRageClickEnabled",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isErrorTriggerEnabled",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CheckoutLiveChatPopUpStepConfig",
    "kind": "LinkedField",
    "name": "stepConfigs",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "step",
        "storageKey": null
      },
      {
        "alias": "isTimeTriggerEnabled",
        "args": null,
        "kind": "ScalarField",
        "name": "isEnabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "showDelay",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hideDelay",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v40 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CheckoutLiveChatPopUpConfig",
    "kind": "LinkedField",
    "name": "returningBuyer",
    "plural": false,
    "selections": (v39/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CheckoutLiveChatPopUpConfig",
    "kind": "LinkedField",
    "name": "newBuyer",
    "plural": false,
    "selections": (v39/*: any*/),
    "storageKey": null
  }
],
v41 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CheckoutLiveChatPopUpReturningBuyerType",
    "kind": "LinkedField",
    "name": "consumerBuyer",
    "plural": false,
    "selections": (v40/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CheckoutLiveChatPopUpReturningBuyerType",
    "kind": "LinkedField",
    "name": "tradeBuyer",
    "plural": false,
    "selections": (v40/*: any*/),
    "storageKey": null
  }
],
v42 = [
  (v28/*: any*/),
  (v31/*: any*/)
],
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": (v42/*: any*/),
  "storageKey": null
},
v44 = [
  (v43/*: any*/)
],
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceBookName",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v49 = [
  (v20/*: any*/),
  (v33/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "multiStageCheckoutTransactionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CheckoutLayout_viewer"
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "checkoutSetUpActions_viewer",
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "checkoutUIActionsTransactionSetup_viewer",
                "selections": [
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "checkoutUIReducer_viewer",
                    "selections": [
                      (v12/*: any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "checkoutTransactionReducerSetup_viewer",
                    "selections": [
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "stripeActivationHelpers_viewer",
                        "selections": [
                          (v13/*: any*/)
                        ],
                        "args": null,
                        "argumentDefinitions": []
                      }
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  }
                ],
                "args": null,
                "argumentDefinitions": []
              }
            ],
            "args": null,
            "argumentDefinitions": []
          },
          {
            "alias": null,
            "args": (v14/*: any*/),
            "concreteType": "TransactionMultiStageCheckoutPayload",
            "kind": "LinkedField",
            "name": "computeTransactionMultiStageCheckout",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Transaction",
                "kind": "LinkedField",
                "name": "transaction",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CheckoutLayout_transaction"
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "checkoutSetUpActions_transaction",
                    "selections": [
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "checkoutUIActionsTransactionSetup_transaction",
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "checkoutUIReducer_transaction",
                            "selections": [
                              {
                                "alias": null,
                                "args": (v16/*: any*/),
                                "concreteType": "TransactionWarningQueryType",
                                "kind": "LinkedField",
                                "name": "warnings",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": [
                              {
                                "kind": "RootArgument",
                                "name": "userCountryCode"
                              }
                            ]
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "checkoutTransactionReducerSetup_transaction",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AvailablePaymentMethodForTransactionType",
                                "kind": "LinkedField",
                                "name": "availablePaymentMethodsForTransaction",
                                "plural": true,
                                "selections": [
                                  (v18/*: any*/),
                                  (v19/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          }
                        ],
                        "args": null,
                        "argumentDefinitions": []
                      },
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "checkoutTrackingActions_transaction",
                        "selections": [
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Offer",
                            "kind": "LinkedField",
                            "name": "mostRecentOffer",
                            "plural": false,
                            "selections": [
                              (v23/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "amountPerItem",
                                "plural": false,
                                "selections": [
                                  (v24/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "args": null,
                        "argumentDefinitions": []
                      },
                      (v21/*: any*/),
                      (v25/*: any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useTrackCheckoutLoadEvent_transaction"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "useTransactionRecomputed_transaction"
                  },
                  (v26/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Invoice",
                    "kind": "LinkedField",
                    "name": "buyerInvoice",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InvoiceItem",
                        "kind": "LinkedField",
                        "name": "invoiceItems",
                        "plural": true,
                        "selections": [
                          (v27/*: any*/),
                          (v30/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransactionSummaryObject",
                    "kind": "LinkedField",
                    "name": "summary",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InvoiceSummary",
                        "kind": "LinkedField",
                        "name": "invoiceSummary",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "buyerCurrentInvoicePromotionTotal",
                            "plural": false,
                            "selections": (v32/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AvailablePaymentMethodForTransactionType",
                    "kind": "LinkedField",
                    "name": "availablePaymentMethodsForTransaction",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v20/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v9/*: any*/),
      (v0/*: any*/),
      (v11/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v8/*: any*/),
      (v1/*: any*/),
      (v10/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "multiStageCheckoutTransactionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "itemId",
                "variableName": "itemId"
              },
              {
                "kind": "Variable",
                "name": "userId",
                "variableName": "buyerId"
              }
            ],
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "activePromotion",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              (v33/*: any*/),
              (v27/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "newDutiesMsgAndTaxEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "newDutiesMessageAndTax"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"newDutiesMessageAndTax\")"
          },
          {
            "alias": "mWebAvalaraUploadFF",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "mWebAvalaraUpload"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"mWebAvalaraUpload\")"
          },
          {
            "alias": "taxExemptCertificateUploadFF",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "taxExemptCertificateUpload"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"taxExemptCertificateUpload\")"
          },
          {
            "alias": "referFriendLink",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "REFER_FRIEND"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale(featureName:\"REFER_FRIEND\")"
          },
          {
            "alias": "sidemarkTrade",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "checkoutSidemarkTrade"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"checkoutSidemarkTrade\")"
          },
          (v12/*: any*/),
          (v13/*: any*/),
          {
            "alias": "isMultiStageCheckoutOn",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "multiStageCheckout"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"multiStageCheckout\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "accountType",
                "value": "TRANSACTION"
              }
            ],
            "concreteType": "MerchantAccount",
            "kind": "LinkedField",
            "name": "merchantAccounts",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryName",
                "storageKey": null
              },
              (v31/*: any*/)
            ],
            "storageKey": "merchantAccounts(accountType:\"TRANSACTION\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "country",
                "variableName": "userCountryCode"
              }
            ],
            "kind": "ScalarField",
            "name": "isCountryInEu",
            "storageKey": null
          },
          {
            "alias": "restrictionsEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "restrictedMaterials"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabled",
            "storageKey": "isEnabled(key:\"restrictedMaterials\")"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "gdprDisplayInfo",
            "kind": "LinkedField",
            "name": "gdprDisplayInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v16/*: any*/),
                "kind": "ScalarField",
                "name": "isGdprApplicable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "marketingOptInMessage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Geography",
            "kind": "LinkedField",
            "name": "geography",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GeographyObject",
                "kind": "LinkedField",
                "name": "countries",
                "plural": true,
                "selections": (v35/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GeographyObject",
                "kind": "LinkedField",
                "name": "usStates",
                "plural": true,
                "selections": (v35/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v36/*: any*/),
          {
            "alias": "enableCheckoutAddressAutocomplete",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "checkoutAddressAutocomplete"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"checkoutAddressAutocomplete\")"
          },
          (v33/*: any*/),
          {
            "alias": "isCvcVerificationOn",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "checkoutCvcVerification"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"checkoutCvcVerification\")"
          },
          {
            "alias": "disable3dsVerificationForCheckout",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "disable3dsVerificationForCheckout"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"disable3dsVerificationForCheckout\")"
          },
          {
            "alias": "default3dsAuthorizationAmountToOne",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "zero3dsAmounts"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"zero3dsAmounts\")"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Token",
            "kind": "LinkedField",
            "name": "clientToken",
            "plural": false,
            "selections": [
              (v37/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "environment",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "multiItemCartFF",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "multiItemCart"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"multiItemCart\")"
          },
          {
            "alias": "isFineGrainedCheckoutErrorsEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "fineGrainedCheckoutErrors"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"fineGrainedCheckoutErrors\")"
          },
          {
            "alias": "isGiftingForAllVerticalsEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "giftingAllVerticals"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"giftingAllVerticals\")"
          },
          {
            "alias": "achDisabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "disableACHCheckout"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabled",
            "storageKey": "isEnabled(key:\"disableACHCheckout\")"
          },
          {
            "alias": "disableApplePay",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "disableApplePay"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabled",
            "storageKey": "isEnabled(key:\"disableApplePay\")"
          },
          {
            "alias": "isKlarnaNegotiationEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "klarnaNegotiationFlow"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"klarnaNegotiationFlow\")"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ContactInfo",
            "kind": "LinkedField",
            "name": "contactInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "support",
                "kind": "LinkedField",
                "name": "phoneNumbers",
                "plural": false,
                "selections": [
                  {
                    "condition": "hasTradeStatus",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "alias": "intlSupport",
                        "args": (v38/*: any*/),
                        "kind": "ScalarField",
                        "name": "support",
                        "storageKey": "support(formatType:\"INTERNATIONAL\")"
                      },
                      {
                        "alias": "defaultSupport",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "support",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "hasTradeStatus",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v38/*: any*/),
                        "kind": "ScalarField",
                        "name": "tradeSupport",
                        "storageKey": "tradeSupport(formatType:\"INTERNATIONAL\")"
                      },
                      {
                        "alias": "defaultTradeSupport",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tradeSupport",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "isStripe3dsDeluxeOn",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "stripe3DSDeluxe"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"stripe3DSDeluxe\")"
          },
          {
            "alias": "isPaymentMethodSelectorEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "checkoutPaymentMethodSelector"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"checkoutPaymentMethodSelector\")"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CheckoutLiveChatConfig",
            "kind": "LinkedField",
            "name": "checkoutLiveChatConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAgentAvailable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isChatEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CheckoutLiveChatPopUpDeviceType",
                "kind": "LinkedField",
                "name": "popUpConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CheckoutLiveChatPopUpBuyerType",
                    "kind": "LinkedField",
                    "name": "mobile",
                    "plural": false,
                    "selections": (v41/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CheckoutLiveChatPopUpBuyerType",
                    "kind": "LinkedField",
                    "name": "desktop",
                    "plural": false,
                    "selections": (v41/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v14/*: any*/),
            "concreteType": "TransactionMultiStageCheckoutPayload",
            "kind": "LinkedField",
            "name": "computeTransactionMultiStageCheckout",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Transaction",
                "kind": "LinkedField",
                "name": "transaction",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransactionSummaryObject",
                    "kind": "LinkedField",
                    "name": "summary",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InvoiceSummary",
                        "kind": "LinkedField",
                        "name": "invoiceSummary",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Invoice",
                            "kind": "LinkedField",
                            "name": "buyerCurrentInvoice",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "totalAmount",
                                "plural": false,
                                "selections": [
                                  (v28/*: any*/),
                                  (v43/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v33/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "buyerCurrentInvoicePromotionTotal",
                            "plural": false,
                            "selections": (v42/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PaymentAuthorization",
                        "kind": "LinkedField",
                        "name": "checkoutPaymentAuthorization",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "authorizationAmount",
                            "plural": false,
                            "selections": (v44/*: any*/),
                            "storageKey": null
                          },
                          (v33/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSkuType",
                    "kind": "LinkedField",
                    "name": "sku",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "ImageMultiSkuOverlayImageSrc",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "size",
                            "value": "large"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "firstPhotoWebPath",
                        "storageKey": "firstPhotoWebPath(size:\"large\")"
                      },
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SkuRingSizeDisplay",
                        "kind": "LinkedField",
                        "name": "ringSizeDisplay",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mm",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "us",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "pageType",
                            "value": "Checkout"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "leadTime",
                        "storageKey": "leadTime(pageType:\"Checkout\")"
                      },
                      {
                        "alias": "availableQuantity",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "quantity",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasUnlimitedQuantity",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SkuQuantityOption",
                        "kind": "LinkedField",
                        "name": "quantitySelectOptions",
                        "plural": true,
                        "selections": [
                          (v45/*: any*/),
                          (v37/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "setSize",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAvailableNow",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "buyerCurrency",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VariableAttributeRow",
                    "kind": "LinkedField",
                    "name": "skuVariableAttributeRows",
                    "plural": true,
                    "selections": [
                      (v45/*: any*/),
                      (v37/*: any*/),
                      (v33/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "displayCurrency",
                        "variableName": "displayCurrency"
                      }
                    ],
                    "concreteType": "BuyerPriceTables",
                    "kind": "LinkedField",
                    "name": "buyerPriceTables",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BuyerPriceTable",
                        "kind": "LinkedField",
                        "name": "tables",
                        "plural": true,
                        "selections": [
                          (v46/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BuyerPriceTableRow",
                            "kind": "LinkedField",
                            "name": "rows",
                            "plural": true,
                            "selections": [
                              (v45/*: any*/),
                              (v37/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rowType",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "formatStyle",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasTopBorder",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "subLabel",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FinancialAmount",
                    "kind": "LinkedField",
                    "name": "vatAmount",
                    "plural": false,
                    "selections": (v29/*: any*/),
                    "storageKey": null
                  },
                  (v47/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Promotion",
                    "kind": "LinkedField",
                    "name": "promotions",
                    "plural": true,
                    "selections": [
                      (v27/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isInvalid",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasBuyerError",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "terms",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "customerSuccessMessage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "validationCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FailureSource",
                        "kind": "LinkedField",
                        "name": "failureSource",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sourceId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "ruleList",
                        "plural": true,
                        "selections": [
                          (v36/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v20/*: any*/),
                              (v18/*: any*/)
                            ],
                            "type": "PaymentMethodTypeRule",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v33/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ],
                        "storageKey": null
                      },
                      (v33/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Offer",
                    "kind": "LinkedField",
                    "name": "mostRecentOffer",
                    "plural": false,
                    "selections": [
                      (v23/*: any*/),
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "kind": "LinkedField",
                        "name": "amountPerItem",
                        "plural": false,
                        "selections": [
                          (v43/*: any*/),
                          (v24/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCrossBorderTransaction",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "crossBorderIncoterm",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasValidTaxExemptCertificate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPendingTaxExemptCertificate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "buyer",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      {
                        "alias": "hasAnyTradeStatus",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isVerifiedTrade",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AddressBook",
                        "kind": "LinkedField",
                        "name": "addressBook",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "addressList",
                            "plural": true,
                            "selections": [
                              (v20/*: any*/),
                              (v48/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayState",
                                "storageKey": null
                              },
                              (v33/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasSupportedChargeCurrency",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserPreferences",
                        "kind": "LinkedField",
                        "name": "preferences",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "buyerChargeCurrency",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isNegotiable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Invoice",
                    "kind": "LinkedField",
                    "name": "buyerInvoice",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "kind": "LinkedField",
                        "name": "totalAmount",
                        "plural": false,
                        "selections": (v44/*: any*/),
                        "storageKey": null
                      },
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "kind": "LinkedField",
                        "name": "totalSalesTax",
                        "plural": false,
                        "selections": (v29/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InvoiceItem",
                        "kind": "LinkedField",
                        "name": "invoiceItems",
                        "plural": true,
                        "selections": [
                          (v27/*: any*/),
                          (v30/*: any*/),
                          (v33/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BuyerPriceTableCopy",
                    "kind": "LinkedField",
                    "name": "uiMessages",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "foreignExchangeDisclaimer",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isShippingKnownAtCheckout",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canBeTaxExempt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isVatOrder",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isVatReverseChargeApplied",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDepositAvailable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "item",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemPriceBook",
                        "kind": "LinkedField",
                        "name": "priceBookNameList",
                        "plural": true,
                        "selections": [
                          (v47/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemPricing",
                            "kind": "LinkedField",
                            "name": "pricing",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "retailPrice",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConvertedAmountList",
                                    "kind": "LinkedField",
                                    "name": "convertedAmountList",
                                    "plural": true,
                                    "selections": (v32/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isVatIncluded",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransactionReview",
                    "kind": "LinkedField",
                    "name": "reviews",
                    "plural": true,
                    "selections": [
                      (v46/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      (v33/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Note",
                    "kind": "LinkedField",
                    "name": "sidemark",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "content",
                        "storageKey": null
                      },
                      (v33/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "hasBuyerReverseChargeAction",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "actionCode",
                        "value": "BUYER_REVERSE_CHARGE_ELIGIBLE"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAction",
                    "storageKey": "hasAction(actionCode:\"BUYER_REVERSE_CHARGE_ELIGIBLE\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canBeVatReverseCharge",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAuctionOrderType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Shipment",
                    "kind": "LinkedField",
                    "name": "shipment",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "shippingAddress",
                        "plural": false,
                        "selections": [
                          (v48/*: any*/),
                          (v33/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v33/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "concreteType": "TransactionWarningQueryType",
                    "kind": "LinkedField",
                    "name": "warnings",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasRestrictedMaterials",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "skuId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Offer",
                    "kind": "LinkedField",
                    "name": "mostRecentBuyerOffer",
                    "plural": false,
                    "selections": (v49/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isGiftEligible",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isFullPriceOrder",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransactionLeadTime",
                    "kind": "LinkedField",
                    "name": "leadTime",
                    "plural": false,
                    "selections": [
                      (v37/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasBuyerTaxError",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AvailablePaymentMethodForTransactionType",
                    "kind": "LinkedField",
                    "name": "availablePaymentMethodsForTransaction",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AvailablePaymentMethodMetadataType",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "STRIPE",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v22/*: any*/),
                  (v25/*: any*/),
                  (v33/*: any*/),
                  (v26/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "condition": "hasUserId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 200
                  },
                  {
                    "kind": "Variable",
                    "name": "userIds",
                    "variableName": "userIds"
                  }
                ],
                "concreteType": "ProjectConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Project",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          (v34/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PortfolioV2",
                            "kind": "LinkedField",
                            "name": "portfolio",
                            "plural": false,
                            "selections": (v49/*: any*/),
                            "storageKey": null
                          },
                          (v33/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-commerce/458.0.0-2024-04-16T08:13:38.881Z/multiStageCheckoutTransactionQuery",
    "metadata": {},
    "name": "multiStageCheckoutTransactionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d04ffd96bb9017cc5374f85cf00154a1";

export default node;
